<template>
    <loading v-if="loading"></loading>

    <div class="aggregate" v-images-loaded="loaded" v-else >

        <table v-for="student in students" class="aggregate__student" >

            <thead>
                <tr class="aggregate__header aggregate__header--print">
                    <th>
                        <h4 class="tag">Kiempunt overzicht klas {{ group.name }} - {{ username(student) }} - {{ currentDate }}</h4>
                    </th>
                </tr>
            </thead>

            <tbody>

                <tr class="aggregate__header aggregate__header--title">
                    <th>
                        <hr>
                        <h1>{{ username(student) }}</h1>
                    </th>
                </tr>

                <tr v-for="assignment in assignments" class="aggregate__assignment" >
                    <td>

                        <div class="aggregate__assignment-wrap">
                            <h2>{{ assignment.title }}</h2>

                            <assignment-progress :progress="progressForStudentAndAssignment(student, assignment, group)"></assignment-progress>
                        </div>

                    </td>
                </tr>

            </tbody>

        </table>

        <img src="" class="dummy-image"/>

    </div>
</template>


<script>

import Loading from 'js/components/elements/Loading.vue'
import AssignmentProgress from 'js/components/students/Progress.vue'
import imagesLoaded from 'vue-images-loaded'
import api from 'js/api/resources'
import { transform } from 'js/vuex/helpers'
import track from 'js/helpers/analytics'


import { username, date } from 'js/helpers/transformers'


export default {
    name: 'StudentsAggregate',
    components: { Loading, AssignmentProgress },

    directives: {
        imagesLoaded,
    },

    props: {
        group: {},
        students: {},
        assignments: {},
    },

    data: function() {
        return {
            loading: false,
        }
    },

    vuex: {
        actions: {
            loadProgress: ({dispatch}, group) => {
                return api.getProgressForGroup(group.id, true)
                    .then( response => transform(response.body) )
                    .then( result => {
                        dispatch('ADD_PROGRESS', result.progress || [])
                        dispatch('ADD_DILIGENCE', result.diligence || [])
                        dispatch('ADD_USERS', result.users || [])
                        dispatch('ADD_FEEDBACK', result.feedback || [])
                        dispatch('ADD_COMPLIMENTS', result.compliments || [])
                        dispatch('ADD_REMARKS', result.remarks || [])
                        dispatch('ADD_DILIGENCE', result.diligence || [])
                        dispatch('ADD_SUBMISSIONS', result.submissions || [])
                    })
            }
        }
    },

    computed: {

        currentDate: function() {
            return date( new Date() )
        },

    },

    methods: {

        username,

        progressForStudentAndAssignment: function(student, assignment, group) {
            return Object.keys(this.$store.state.progress.storage)
                .map( id => this.$store.state.progress.storage[id] )
                .find( progress => progress.finished && progress.user == student.id && progress.assignment == assignment.id && progress.group == group.id)
        },

        loaded: function() {
            this.$emit('load')
        },

    },

    created: function() {
        this.loading = true

        this.loadProgress(this.group, true)
            .catch( err => track.exception('Could not load students progress', err) )
            .then( () => this.loading = false )

    }
}
</script>


<style lang="scss">

    @import 'global';

    .aggregate {

        @media print {
            font-size: 0.8em;
        }

        &__student {
            page-break-before: always;
            width: 100%;
        }

        &__header {

            h1 {
                text-align: center;
            }

            &--print {
                display: none;
            }

            @media print {

                &--print {
                    color: $color-grey;
                    display: table-row;
                }

                hr {
                    display: none;
                }

            }
        }


        &__assignment {
            page-break-inside: avoid;
            margin: 0;

            @include clearfix();

            h2 {
                margin-bottom: 0.1em;
            }


            img {
                // max-width: 50%;
                margin: 1em auto;
                border-radius: 4px;
            }
        }

        &__assignment-wrap {
            // avoid page break on Safari
            display: inline-block;
            width: 100%;
            vertical-align: top;
        }

    }


</style>



// WEBPACK FOOTER //
// Aggregate.vue?6740ceea